import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/atoms/card';
import { FormImageUpload } from '@/components/forms';

interface ImagePreview {
  src: string;
  isNew?: boolean;
  id?: number | string;
}

interface ShopImagesProps {
  previews: ImagePreview[];
  onAdd: (files: FileList) => void;
  onRemove: (index: number, id?: number | string) => void;
  onReorder?: (fromIndex: number, toIndex: number) => void;
  isCompressing?: boolean;
  maxImages?: number;
}

export function ShopImages({
  previews,
  onAdd,
  onRemove,
  onReorder,
  isCompressing = false,
  maxImages = 2, // Server only accepts 2 images for shops (logo + cover)
}: ShopImagesProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('shops.images')}</CardTitle>
        <CardDescription>{t('shops.imagesDescription')}</CardDescription>
      </CardHeader>
      <CardContent>
        <FormImageUpload
          previews={previews}
          maxImages={maxImages}
          onAdd={onAdd}
          onRemove={onRemove}
          onReorder={onReorder}
          isCompressing={isCompressing}
          mainLabel={t('shops.logo')}
          secondaryLabel={t('shops.banner')}
          emptyStateTitle={t('shops.clickToUpload')}
          emptyStateDescription={t('shops.imageHint')}
          addMoreLabel={t('shops.addMore')}
          newBadgeLabel={t('common.new', { defaultValue: 'New' })}
          reorderHint={t('shops.dragToReorder', { defaultValue: 'Drag to reorder' })}
        />
      </CardContent>
    </Card>
  );
}
